<template>
    <v-app>
      <v-main>
        <calendar-main/>
      </v-main>
      <success-snackbar/>
      <failure-snackbar/>
    </v-app>
</template>

<script>
import {CalendarMain, FailureSnackbar, SuccessSnackbar} from './components';

export default {
  name: 'App',
  components: {
    CalendarMain,
    FailureSnackbar,
    SuccessSnackbar
  },

  data: () => ({
    //
  }),
};
</script>

<style>
.info-input .v-label{
  font-size: 14px !important;
}

.info-input input{
  font-size: 14px !important;
}

.info-input .v-messages__message {
  font-size: 10px !important;
}

* {
  user-select: none;
  -webkit-user-select: none;
}
</style>
